/**
 * @file NoticeRiskPreview.tsx
 * @description Образец окна о риске режима «Уведомление» (phase19.16, Р3г;
 * uiux-r3g-consent-texts §3 «Окно о риске»: предпросмотр — так, как окно
 * видит владелец в «Счётчики и cookie»; раскладка — `NoticeRiskDialog`).
 * Кнопки и галочка — картинка, не элементы управления.
 */

import type { ConsentNoticeRiskTexts } from "@chaiberi/shared";

import { NOTICE_RISK_BUTTON_LABELS } from "../../../lib/site-view/notice-risk-labels";

interface Props {
  texts: ConsentNoticeRiskTexts;
}

export function NoticeRiskPreview({ texts }: Props) {
  return (
    <div className="flex justify-center p-4">
      <div
        data-preview-form="risk"
        className="flex w-full max-w-md flex-col gap-4 rounded-xl bg-surface-lowest p-6 text-on-surface [box-shadow:inset_0_0_0_1px_var(--outline-variant)]"
      >
        <div className="flex flex-col gap-1">
          <p className="m-0 text-base font-semibold">{texts.title}</p>
          <p className="m-0 text-sm text-on-surface-variant">{texts.body}</p>
        </div>
        <div className="flex min-h-12 items-start gap-3 rounded-xl bg-warning/12 px-3 py-3">
          <span aria-hidden className="mt-[3px] size-4 shrink-0 rounded-sm [box-shadow:inset_0_0_0_1.5px_var(--outline-variant)]" />
          <span className="text-sm">{texts.acknowledge}</span>
        </div>
        <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
          <span className="inline-flex min-h-12 items-center justify-center rounded-lg px-4 text-sm">{NOTICE_RISK_BUTTON_LABELS.keepConsent}</span>
          <span className="inline-flex min-h-12 items-center justify-center rounded-lg bg-on-surface px-4 text-sm text-surface-lowest">
            {NOTICE_RISK_BUTTON_LABELS.enableNotice}
          </span>
        </div>
      </div>
    </div>
  );
}
